export default "__VITE_ASSET__BpMNOifN__"